// extracted by mini-css-extract-plugin
export var bg_grey_20 = "styles-module--bg_grey_20--THdJE";
export var bg_grey_black = "styles-module--bg_grey_black--2h+H9";
export var blink = "styles-module--blink--l-4cZ";
export var content = "styles-module--content--IVGhz";
export var heroSection = "styles-module--heroSection--Ge9gS";
export var storiesSection = "styles-module--storiesSection--zNGpo";